module.exports = __webpack_public_path__ + "img/96.eb5c37f1.jpg";